import * as _ from "lodash-es";
import React, { Component } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../../models/DTO/IGetCatalogsDTO";
import IGetVendorPriceGroupMapDTO from "../../../../../models/DTO/IGetVendorPriceGroupMapDTO";
import IOnGetCatalogsDTO from "../../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetVendorPriceGroupMapDTO from "../../../../../models/DTO/IOnGetVendorPriceGroupMapDTO";
import IOnUpdateVendorPriceGroupMapDTO from "../../../../../models/DTO/IOnUpdateVendorPriceGroupMapDTO";
import IUpdateVendorPriceGroupMapDTO from "../../../../../models/DTO/IUpdateVendorPriceGroupMapDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ICatalog from "../../../../../models/ICatalog";
import INotification from "../../../../../models/INotification";
import IPrice_Group from "../../../../../models/IPrice_Group";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import IVendor_Price_Group_Map from "../../../../../models/IVendor_Price_Group_Map";
import IVendorModel from "../../../../../models/IVendorModel";
import NotificationLevelEnum from "../../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../../models/NotificationPositionEnum";
import OwPickList from "../../../../shared/OwPickList/OwPickList";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
};

type State = {
    originalVendorPriceGroupMap: IVendor_Price_Group_Map[];
    selectedCatalog?: ICatalog;
    priceGroupOptions: IPrice_Group[];
    catalogOptions: ICatalog[];
    selectedPriceGroupOptions: any[];
    priceGroupPickListComponent: boolean;
    selectedPriceGroups: any[];
};

class EditPriceGroupAccess extends Component<Props, State> {
    readonly state: State = {
        priceGroupOptions: [],
        catalogOptions: [],
        selectedPriceGroupOptions: [],
        priceGroupPickListComponent: false,
        selectedPriceGroups: [],
        originalVendorPriceGroupMap: [],
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.on(EndpointsEnum.VendorsOnUpdateVendorPriceGroupMap, this.onUpdateVendorPriceGroupMap);
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendorPriceGroupMap, this.onGetVendorPriceGroupMap);

        this.getCatalogs();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.removeListener(EndpointsEnum.VendorsOnUpdateVendorPriceGroupMap, this.onUpdateVendorPriceGroupMap);
        this.props.socket.removeListener(EndpointsEnum.VendorsOnGetVendorPriceGroupMap, this.onGetVendorPriceGroupMap);
    }

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            // vendorGuid: this.props.vendorModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "EditPriceGroupAccess",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogOptions: data.catalogs,
            priceGroupOptions: [],
        });
    };

    savePriceGroupAccess = (selectedOptionsArr: any[]) => {
        this.setState(
            {
                selectedPriceGroups: selectedOptionsArr,
            },
            () => {
                this.updateVendorPriceGroupMap();
            }
        );
    };

    updateVendorPriceGroupMap = () => {
        // @ts-expect-error
        const vendorMap: IVendor_Price_Group_Map[] = _.map(this.state.selectedPriceGroups, (selectedPriceGroup: any) => {
            // find from the original if one for this price group exists.
            let existingId: number | undefined = undefined;

            _.each(this.state.originalVendorPriceGroupMap, (mapDetail) => {
                if (Number(mapDetail.price_group_id) === Number(selectedPriceGroup.value)) {
                    existingId = mapDetail.id;
                }
            });

            return {
                price_group_id: Number(selectedPriceGroup.value),
                vendor_id: this.props.vendorModel.id,
                id: existingId,
            } as Partial<IVendor_Price_Group_Map>;
        });

        // mark any of the original ones not in the selected, marked for deletion.
        const markedForDeleteMaps: IVendor_Price_Group_Map[] = [];

        _.each(this.state.originalVendorPriceGroupMap, (originalMap) => {
            let found = false;

            _.each(vendorMap, (updatedMap) => {
                if (Number(updatedMap.price_group_id) === Number(originalMap.price_group_id)) {
                    found = true;
                }
            });

            if (!found) {
                markedForDeleteMaps.push({ ...originalMap, deleteFlag: true });
            }
        });

        const finalVendorMap = [...vendorMap, ...markedForDeleteMaps];

        const payload: IUpdateVendorPriceGroupMapDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.vendorModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            vendorMap: finalVendorMap,
        };

        this.props.socket.emit(EndpointsEnum.VendorsUpdateVendorPriceGroupMap, payload);
    };

    onUpdateVendorPriceGroupMap = (data: IOnUpdateVendorPriceGroupMapDTO) => {
        const notification: INotification = {
            title: "successfully_updated_price_group_access",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.tr,
        };

        this.props.notifyFn(null, notification);
    };

    getVendorPriceGroupMap = () => {
        const payload: IGetVendorPriceGroupMapDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.vendorModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.selectedCatalog!.guid,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendorPriceGroupMap, payload);
    };

    onGetVendorPriceGroupMap = (data: IOnGetVendorPriceGroupMapDTO) => {
        const processedSelectedPriceGroupOptions = _.map(data.vendorMap, (mapDetail) => {
            return {
                id: mapDetail.price_group_id,
                value: mapDetail.Price_Group ? mapDetail.Price_Group.value : "Error",
            };
        });

        this.setState({
            priceGroupPickListComponent: true,
            originalVendorPriceGroupMap: data.vendorMap,
            selectedPriceGroupOptions: processedSelectedPriceGroupOptions,
        });
    };

    selectCatalog = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        const name = e.target.name;

        let catalog: ICatalog | undefined;

        _.find(this.state.catalogOptions, (_catalog) => {
            if (Number(_catalog.id) === Number(value)) {
                catalog = _catalog;
            }
        });

        if (catalog) {
            const priceGroups = catalog.Price_Groups || [];

            this.setState(
                {
                    selectedCatalog: catalog,
                    priceGroupPickListComponent: false,
                    priceGroupOptions: priceGroups,
                },
                () => {
                    this.getVendorPriceGroupMap();
                }
            );
        }
    };

    render() {
        return (
            <div className="EditPriceGroupAccess d-flex">
                <div className={"col-auto"}>
                    <OwTitle title={"catalog"} tag={"h5"} />
                    <OwSelectOption
                        options={this.state.catalogOptions}
                        valueProp={"id"}
                        fn={this.selectCatalog}
                        name={"catalog"}
                        titleProp={"name"}
                        showBlankFirst={true}
                    />
                </div>
                <div className={"col"}>
                    <OwTitle title={"price_groups"} tag={"h5"} />
                    {this.state.priceGroupPickListComponent ? (
                        <OwPickList
                            availableOptions={this.state.priceGroupOptions}
                            titleProp={"value"}
                            valueProp={"id"}
                            selectedOptions={this.state.selectedPriceGroupOptions}
                            saveFn={this.savePriceGroupAccess}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

export default EditPriceGroupAccess;
